import { IFetchCloudeProject } from 'lib/types/utilTypes';
import { axs } from './config/axiosConfig';
import { BASE_API_URL } from 'lib/setting';

const basePath = `${BASE_API_URL}/file`;

export function fetchProjectFiles(id: string) {
  return axs({ url: `${basePath}/project/${id}`, method: 'get' });
}

export function fetchProjectFileUploadUrl(payload: {
  projectCode: string;
  fileGroupId: string;
  fileName: string;
  fileSize?: number;
  isShare: number;
}) {
  return axs({ url: `${basePath}/upload/project`, method: 'post', data: payload });
}

export function fetchProjectFileDownloadUrl(payload: { cloudDataIdx: number }) {
  return axs({ url: `${basePath}/download/project`, method: 'post', data: payload });
}

// "projectCode" : "20210225-babcec1d-2788-43a7-a79e-baeb5ccf7e82", "cloudFileList" : [ 188 ]
// { projectCode: string; cloudFileList: any[] }
export function deleteProjectFile(payload: { projectCode: string; cloudDataList: number[] }) {
  return axs({ url: `${basePath}/project`, method: 'delete', data: payload });
}

export function completeProjectFileUpload({
  fileType,
  data,
}: {
  fileType: string;
  data: {
    duplicateCloudDataIdx: number;
    cloudDataIdx: number;
    isSuccess: number;
  };
}) {
  return axs({ url: `${basePath}/upload/${fileType}/complete`, method: 'put', data: data });
}

export function editProjectShare(payload: {
  projectCode: string;
  cloudDataList: number[];
  isShare: number;
}) {
  return axs({ url: `${basePath}/project/share`, method: 'put', data: payload });
}

export function fetchEmployeeImageFileUploadUrl(payload: {
  syncUid: string;
  fileName: string;
  fileSize: number;
}) {
  return axs({ url: `${basePath}/upload/employee`, method: 'post', data: payload });
}

export function deleteEmployeeImageFile(payload: { profileIdx: number }) {
  return axs({ url: `${basePath}/employee`, method: 'delete', data: payload });
}

export function fetchPartnerImageFileUploadUrl(payload: {
  groupCode: string;
  fileName: string;
  fileSize: number;
}) {
  return axs({ url: `${basePath}/upload/partner`, method: 'post', data: payload });
}

export function deletePartnermageFile(payload: { profileIdx: number }) {
  return axs({ url: `${basePath}/partner`, method: 'delete', data: payload });
}

export function completeImageFileUpload({
  fileType,
  data,
}: {
  fileType: string;
  data: {
    profileIdx: number;
    isSuccess: number;
    deleteProfileIdx: number;
  };
}) {
  return axs({ url: `${basePath}/upload/${fileType}/complete`, method: 'put', data: data });
}

export function fetchQnaFileUploadUrl(payload: {
  qnaIdx: number;
  fileName: string;
  fileSize: number;
}) {
  return axs({ url: `${basePath}/upload/qna`, method: 'post', data: payload });
}

export function fetchQnaFileDownloadUrl(payload: { cloudDataIdx: number }) {
  return axs({ url: `${basePath}/download/qna`, method: 'post', data: payload });
}

export function fetchCloudProjectList(params: IFetchCloudeProject) {
  return axs({ url: `${basePath}/project`, method: 'get', params: params });
}

export function deleteCloudProjects(payload: { projectIdxList: number[] }) {
  return axs({ url: `${basePath}/project/dump`, method: 'delete', data: payload });
}

export function deleteCloudProjectByPeriod(payload: { days: string }) {
  return axs({ url: `${basePath}/project/days`, method: 'delete', data: payload });
}
